import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const CampbellfieldCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Campbellfield" suburbSlug="campbellfield" variant="cdbs-dentist" />
);

export default CampbellfieldCdbsDentistPage;
